import { type ReactNode, useEffect } from "react"
import { X } from "lucide-react"
import { cn } from "../../lib/utils"

interface DialogProps {
  open: boolean
  onClose: () => void
  children: ReactNode
  className?: string
  title?: string
}

export function Dialog({ open, onClose, children, className, title }: DialogProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
    return () => { document.body.style.overflow = "" }
  }, [open])

  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className={cn(
        "relative z-10 w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-xl bg-white dark:bg-ink-900 shadow-2xl border border-ink-200 dark:border-ink-800",
        className
      )}>
        {title && (
          <div className="flex items-center justify-between p-4 border-b border-ink-200 dark:border-ink-800">
            <h2 className="font-display font-bold text-lg text-ink-900 dark:text-ink-100">{title}</h2>
            <button onClick={onClose} className="text-ink-400 hover:text-ink-700 dark:hover:text-ink-200">
              <X className="w-5 h-5" />
            </button>
          </div>
        )}
        <div className="p-4">{children}</div>
      </div>
    </div>
  )
}
